// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connectForm {
    width: 100%;
    height: 600px;
    padding: 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: visible;
}

.remoteContainer {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    margin: 0 auto;
    padding: 0;
    overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Shared/RemoteSupport.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,UAAU;IACV,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,cAAc;IACd,UAAU;IACV,cAAc;AAClB","sourcesContent":[".connectForm {\r\n    width: 100%;\r\n    height: 600px;\r\n    padding: 0;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    overflow: visible;\r\n}\r\n\r\n.remoteContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n    display: block;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    overflow: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
